import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { Select } from '@/components/ui'
import { BucketType, TimeRange } from '@/schema'

import { useDashboardStore } from '../../store'
import { getTimeRangeOptions } from '../../utils'

export const PeriodMetricFilter: React.FC = () => {
  const { t } = useTranslation()
  const { aggregationPeriod, timeRange, setAggregationPeriod, setTimeRange } =
    useDashboardStore()

  const timeRangeOptions = useMemo(
    () =>
      getTimeRangeOptions(aggregationPeriod).map((range) => ({
        value: range,
        label: t(`dashboard.timeRanges.${range}`),
      })),
    [aggregationPeriod, t]
  )

  return (
    <div className="flex flex-wrap gap-3 items-end justify-end">
      <Select
        options={[
          {
            value: BucketType.week,
            label: t('dashboard.periods.week'),
          },
          {
            value: BucketType.month,
            label: t('dashboard.periods.month'),
          },
        ]}
        value={aggregationPeriod}
        onChange={(value) =>
          setAggregationPeriod((value as BucketType) || aggregationPeriod)
        }
        className="w-24"
        valueClassName="font-medium text-primary-900"
        disableSorting
      />

      <Select
        options={timeRangeOptions}
        value={timeRange}
        onChange={(value) => setTimeRange((value as TimeRange) || timeRange)}
        className="w-40"
        valueClassName="font-medium text-primary-900"
        disableSorting
      />
    </div>
  )
}
